import { render, staticRenderFns } from "./IncidentModal.vue?vue&type=template&id=32445ac2&scoped=true"
import script from "./IncidentModal.vue?vue&type=script&lang=js"
export * from "./IncidentModal.vue?vue&type=script&lang=js"
import style0 from "./IncidentModal.vue?vue&type=style&index=0&id=32445ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32445ac2",
  null
  
)

export default component.exports